import { IKlantContactResponse } from "@opencak-klantondersteuning/client";
import { ISubmitResult } from "../interfaces";

export class ResponseMapper {
  map = (response: IKlantContactResponse): ISubmitResult => {
    return {
      klantContactId: response.klantContactId || 0,
      bericht: response.bericht || ""
    };
  };
}
